import { render, staticRenderFns } from "./export_stu.vue?vue&type=template&id=37f08ace&"
import script from "./export_stu.vue?vue&type=script&lang=js&"
export * from "./export_stu.vue?vue&type=script&lang=js&"
import style0 from "./export_stu.vue?vue&type=style&index=0&id=37f08ace&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports